import React, { useState } from "react";
import AccountDrawer from "./AccountDrawer";
import FAQ from "./FAQ";
import Policy from "./Policy";
import SubscriptionManager from "./SubscriptionManager";
import Support from "./Support";
import TermsConditions from "./TermsConditions";

const SettingsPage = ({ onBack, userEmail = "Chris@nxthvl.io" }) => {
  const [activeComponent, setActiveComponent] = useState(null);

  const toggleComponent = (component) => {
    setActiveComponent(component);
  };

  const handleLogout = () => {
    console.log("Logging out...");
  };

  return (
    <div
      className="min-h-screen"
    >
      {activeComponent === null && (
        <>
        <div style={{
            background: "linear-gradient(to bottom, rgba(225, 225, 225, 1) 0%, rgba(225, 225, 225, 0) 100%)",
            minHeight: "80px",
            padding: "35px 21px 26px"
      }}>

          {/* Header */}
          <div className="w-full flex items-center">
            <button
              onClick={onBack}
              className=" absolute top-[34px] bg-white rounded-full p-1 shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-gray-400"
                fill="none"
                viewBox="0 0 26 26"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            {/* Title */}
            <h1 className="text-[20px] leading-[20px] text-[#1E0A1E] font-normal font-young-serif text-center mx-auto">
              Settings
            </h1>
          </div>
          </div>

          <div className="text-[20px] font-young-serif p-6 pt-0">
          <div className="mx-1 border-t border-[#EEEEEE]" />
            {[
              { label: "Account", action: () => toggleComponent("AccountDrawer") },
              {
                label: "Manage Subscription",
                action: () => toggleComponent("SubscriptionManager"),
              },
              {
                label: "Support",
                action: () => toggleComponent("Support"),
              },
              { label: "FAQs", action: () => toggleComponent("FAQ") },
              { label: "Privacy Policy", action: () => toggleComponent("Policy") },
              { label: "Terms & Conditions", action: () => toggleComponent("TermsConditions") }
            ].map((item, index) => (
              <button
                key={index}
                onClick={item.action}
                className="w-full flex justify-between items-center py-4 px-6 border-b last:border-0 text-[#1E0A1E] "
              >
                <span className="font-normal">{item.label}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={2}
                  stroke="currentColor"
                  className="h-6 w-6 text-[#0F172A]"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M9 5l7 7-7 7"
                  />
                </svg>
              </button>
            ))}
          </div>

          <div className="mt-12 space-y-4 p-6">
            <div className="text-center space-y-1">
              <p className="text-[12px] text-[#1E0A1E] font-medium font-space-grotesk">Logged in as</p>
              <p className="text-[12px] text-[#929292] font-normal font-space-grotesk">{userEmail}</p>
            </div>
            <div className="text-center">
              <p className="text-[12px] text-[#1E0A1E] font-medium font-space-grotesk">Version 01</p>
            </div>
            <div className="flex justify-center mt-6 mb-8">
          <button onClick={handleLogout} className="bg-[#1E0A1E] text-[#EEEEEE] font-space-grotesk text-[16px] font-medium py-2 px-6 rounded-full shadow-[2px_2px_4px_rgba(0,0,0,0.05),_5px_5px_2px_rgba(0,0,0,0.15)]">
          Log out
          </button>
        </div>

          </div>
        </>
      )}

      {activeComponent === "SubscriptionManager" && (
        <SubscriptionManager onBack={() => setActiveComponent(null)} />
      )}
      {activeComponent === "AccountDrawer" && (
        <AccountDrawer onClose={() => setActiveComponent(null)} />
      )}
      {activeComponent === "Support" && (
        <Support onBack={() => setActiveComponent(null)} />
      )}
      {activeComponent === "FAQ" && <FAQ onBack={() => setActiveComponent(null)} />}
      {activeComponent === "Policy" && <Policy onBack={() => setActiveComponent(null)} />}
      {activeComponent === "TermsConditions" && <TermsConditions onBack={() => setActiveComponent(null)} />}
    </div>
  );
};

export default SettingsPage;